const config = {
  basePath: '/checkout/app',
  baseRoutePath: '/checkout',
  checkForNewVersion: 21600, //seconds => 6h - this is time based polling, even if the browser tab is open
  focusAwayTimeout: 600, //seconds => 10 mins - if the focus was away for more than this, check if there is a new version
};
export default config;
